import React from 'react';

const LogoButton = ({ handleClick }) => {
  return (
    <button className="logo-button" onClick={handleClick}>
      <span>
        <svg width="22px" height="18px">
          <use href="#logo"></use>
        </svg>
      </span>
      Элитные розы
    </button>
  );
};

export default LogoButton;
